import React from 'react';

import { fg } from '@townsquare/stat-sig/gate';

import { LoadingState } from './LoadingState';
import {
	DesktopRestrictedLoadingState as StyledDesktopRestrictedLoadingState,
	MobileRestrictedLoadingState as StyledMobileRestrictedLoadingState,
} from './styles';
import {
	DesktopRestrictedLoadingState as CompiledDesktopRestrictedLoadingState,
	MobileRestrictedLoadingState as CompiledMobileRestrictedLoadingState,
} from './styles.compiled';
import { LoadingStateProps } from './types';

const DesktopRestrictedLoadingState = fg('townsquare_compiled_css_migration_goals')
	? CompiledDesktopRestrictedLoadingState
	: StyledDesktopRestrictedLoadingState;
const MobileRestrictedLoadingState = fg('townsquare_compiled_css_migration_goals')
	? CompiledMobileRestrictedLoadingState
	: StyledMobileRestrictedLoadingState;

const MobileLoadingState = (props: LoadingStateProps) => (
	<MobileRestrictedLoadingState>
		<LoadingState {...props} />
	</MobileRestrictedLoadingState>
);

/*
 * Lets you show a custom loading state on desktop and a spinner on mobile, in case the space
 * available makes showing a spinner the better option
 */
export const ResponsiveLoadingState = ({
	children: customLoadingComponent,
	...loadingStateProps
}: {
	children: React.ReactNode;
}): React.JSX.Element => (
	<>
		<DesktopRestrictedLoadingState>{customLoadingComponent}</DesktopRestrictedLoadingState>
		<MobileLoadingState {...loadingStateProps} />
	</>
);
